<template>
  <div class="krs019">
    <ul>
      <li>
        <dl class="clear">
          <dt>{{$i18nUtil.trans("message.CwpoManage.001","정보차단벽 정책명")}}</dt>
          <dd>
            <div v-show="cwpoNameState == 'VIEW'">
              <div class="txt" style="overflow: hidden; text-overflow: ellipsis; padding: 2px;">{{ cwpoName }}</div>
              <button
                  type="button"
                  class="btn-primary-small"
                  @click="changeCwpoNameState"
                  style="right: -110px; width: 111px;"
              >{{$i18nUtil.trans("message.CwpoManage.002","정책명 수정")}}
              </button>
            </div>
            <div v-show="cwpoNameState == 'EDIT'">
              <div class="edit-box">
                <input
                  type="text"
                  v-model="cwpoName"
                />
              </div>
              <button
                type="button"
                class="btn-primary-small black"
                style="right: -110px; width: 111px;"
              >{{$i18nUtil.trans("message.CwpoManage.002","정책명 수정")}}
              </button>
            </div>
          </dd>
        </dl>
      </li>
      <li>
        <dl class="clear">
          <dt>{{$i18nUtil.trans("entity.user.deptName.002","부서명")}}</dt>
          <dd>
            <div>
              <div class="txt" style="overflow: hidden; text-overflow: ellipsis; padding: 2px;">{{ objectName }}</div>
              <!-- 2022-03-24 : 정보차단벽 정책 수정시 부서 수정 버튼숨김 : 조성기  
                <button
                  type="button"
                  class="btn-primary-small"
                  @click="modifyDept('dept')"
                  style="right: -110px; width: 111px;"
              >{{$i18nUtil.trans("message.CwpoManage.003","부서 수정")}}
              </button> -->
            </div>
          </dd>
        </dl>
      </li>
      <li>
        <dl class="clear">
          <dt>{{$i18nUtil.trans("message.CwpoManage.004","대상부서명")}}</dt>
          <dd>
            <div>
              <div v-show="blockObjNameState == 'VIEW'">
                <div class="txt" style="overflow: hidden; text-overflow: ellipsis; padding: 2px;">{{ blockObjectName }}</div>
              </div>
              <!-- <div v-show="blockObjNameState == 'EDIT'"> 
                <div class="edit-box">
                  <input
                    type="text"
                    v-model="blockObjectName"
                  />
                </div>
              </div> -->
              <!-- 2022-03-24 : 정보차단벽 정책 수정시 부서 수정 버튼숨김 : 조성기 
              <button
                  type="button"
                  class="btn-primary-small"
                  @click="shareTeam"
                  style="right: 18px"
              >{{$i18nUtil.trans("message.CwpoManage.005","팀내만 공유")}}
              </button>
              <button
                    type="button"
                    class="btn-primary-small"
                    @click="modifyDept('blockDept')"
                    style="right: -110px"
              >{{$i18nUtil.trans("message.CwpoManage.006","대상부서 수정")}}
              </button> -->
            </div>
          </dd>
        </dl>
      </li>
    </ul>
    <button
      type="button"
      class="btn-primary-small black"
      @click="updateCwpo"
      style="float: right; margin-top: 10px;"
    >{{$i18nUtil.trans("button.save","저장")}}
    </button>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
import CoSysOrg from "@/components/cowork/common/organization/org/CoSysOrg";
export default {
  components: {
    Dialog,
  },
  props: {
    modalInfo: {
      type: Object,
    },
  },
  data() {
    return {
      cwpoNameState: "VIEW",
      blockObjNameState: "VIEW",
      cwpoName: null,
      objectId: null,
      objectName: null,
      blockObjectId: null,
      blockObjectName: null,
      beforeObjectId: null,
      beforeBlockObjectId: null,
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },
  created() {
    EventBus.$off("returnDept");
    EventBus.$on("returnDept", param => {
      let obj = this;
      if (param.deptType == "dept") {
        obj.objectName = param.deptName;
        obj.objectId = param.deptId;
      }else{
        obj.blockObjectName = param.deptName;
        obj.blockObjectId = param.deptId;
      }
    });
    this.getCwpoInfo();
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast", "showDialog"]),
    getCwpoInfo() {
      let obj = this;
      
      let reqData = {};
      reqData.params = {
        cwpoId: this.modalInfo.cwpoId,
      };
      reqData.url = "/api/org/cwpo/getCwpoInfo";
      reqData.method = "post";

      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            obj.cwpoName = res.result.cwpoName;
            obj.objectName = res.result.objectName;
            obj.blockObjectName = res.result.blockObjectName;
            obj.objectId = res.result.objectId;
            obj.blockObjectId = res.result.blockObjectId;
            obj.beforeObjectId = res.result.objectId;
            obj.beforeBlockObjectId = res.result.blockObjectId;
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    //정보차단정책값 수정
    updateCwpo(e) {
      let obj = this;
      let changeDept = true;
      if(obj.objectId == obj.beforeObjectId && obj.blockObjectId == obj.beforeBlockObjectId){
        changeDept = false;
      }
      let blockObjName = obj.blockObjectName.toUpperCase();
      if(blockObjName == 'ALL'){
        obj.blockObjectId = blockObjName;
      }
      if(obj.objectId == obj.blockObjectId){
        obj.toastInfo.message =obj.$i18nUtil.trans("message.CwpoManage.007","부서와 대상부서는 동일한 부서로 선택할 수 없습니다.");
        obj.showToast(obj.toastInfo);
      }else{
        let reqData = {};
        reqData.params = {
          cwpoId: this.modalInfo.cwpoId,
          cwpoName: obj.cwpoName,
          objectId: obj.objectId,
          blockObjectId: obj.blockObjectId,
          changeDept: changeDept,
        };
        reqData.url = "/api/org/cwpo/updateCwpo";
        reqData.method = "post";

        //프로그레스바 시작
        this.showLoadingbar();
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then((res) => {
            //프로그레스바 종료
            this.hideLoadingbar();
            if (res.errorCode) {
              console.log(res.errorCode);
            } else {
              if(res.result != null){
                if(res.result == "objDupl"){
                  obj.toastInfo.message = obj.$i18nUtil.trans("message.CwpoManage.008","기존의 정책과 중복 되는 정책이므로 수정할 수 없습니다. 부서명과 대상부서명을 다시 수정해 주세요.");
                  obj.showToast(obj.toastInfo);
                }else if(res.result == "blockObjDupl"){
                  obj.toastInfo.message = obj.$i18nUtil.trans("message.CwpoManage.008","기존의 정책과 중복 되는 정책이므로 수정할 수 없습니다. 부서명과 대상부서명을 다시 수정해 주세요.");
                  obj.showToast(obj.toastInfo);
                }else if(res.result.resultMessage == "EXIST_POLICY"){
                  // obj.toastInfo.message = obj.$i18nUtil.trans("message.CwpoManage.008","기존의 정책과 중복 되는 정책이므로 수정할 수 없습니다. 부서명과 대상부서명을 다시 수정해 주세요.");
                  let policyName = "";
                  res.result.policyNameList.forEach(element => {
                    policyName += "["+element+"]";
                  });
                  obj.toastInfo.message = "부서 정책이 존재합니다. 해당 정책 삭제 후 추가 시도 부탁 드립니다.<br>"+policyName;

                  obj.showToast(obj.toastInfo);
                }
              }else{
                obj.toastInfo.message = obj.$i18nUtil.trans("message.CwpoManage.009","정보차단벽 정보가 변경되었습니다.");
                obj.showToast(obj.toastInfo);
                obj.$emit("updateCwpo");
                obj.cwpoNameState = "VIEW";
                obj.blockObjNameState = "VIEW";
              }            
            }
          })
          .catch((err) => {
            console.log("axios err => ", err);
          });
      }
    },
    changeCwpoNameState(e) {
      this.cwpoNameState = "EDIT";
    },
    changeBlockObjNameState(e) {
      this.blockObjNameState = "EDIT";
    },    
    modifyDept(deptType){
      let modalInfo = {};
        modalInfo = {
          obj: this.$modal,
          component: CoSysOrg,
          deptType: deptType,
          width: "600px",
          height: "450px",
        };
      this.showModal(modalInfo);
    },
    shareTeam(){
      this.blockObjectId = 'ALL';
      this.blockObjectName = 'ALL';
    },
  },
};
</script>

<style scoped>
.edit-box > input {
  width: 90%;
}
.edit-box input {
  height: 21px;
  padding: 0 0 0 5px;
  line-height: 21px;
  color: #000;
  border: 0 none;
}
.krs019 > ul > li > dl > dt {
  width: 150px;
}
.krs019 > ul > li:nth-child(1) > dl > dd {
  width: 900px;
}
.krs019 > ul > li:nth-child(2) > dl > dd {
  width: 900px;
}
.krs019 > ul > li:nth-child(3) > dl > dd {
  width: 900px;
}

</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/modal/CwpoManage.vue